// extracted by mini-css-extract-plugin
module.exports = {"swipe":"ChartTable_swipe__29Nlj","block_val":"ChartTable_block_val__DuS8t","chart_table_wrap":"ChartTable_chart_table_wrap__3dSCg","chart_table":"ChartTable_chart_table__lwuUu"};